import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import Confetti from "react-confetti";

function TodaysDate() {
  const today = new Date();
  const dateString = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  return dateString;
}

const questions = {
  "2023-10-27": {
    date: "2023-10-27",
    question:
      "Which footballer\u2019s extramarital affairs came to light after he lost a court battle to keep them secret?",
    options: [
      {
        id: 1,
        label: "A) Ryan Giggs",
      },
      {
        id: 2,
        label: "B) Cristiano Ronaldo",
      },
      {
        id: 3,
        label: "C) John Terry",
      },
      {
        id: 4,
        label: "D) Lionel Messi",
      },
    ],
    correct: 1,
    insight:
      "Ryan Giggs lost a legal battle to prevent his name being published in relation to extramarital affairs, causing a media frenzy.",
  },
  "2023-10-28": {
    date: "2023-10-28",
    question: "Who was handed a lengthy ban for biting Otman Bakkal in 2010?",
    options: [
      {
        id: 1,
        label: "A) Zinedine Zidane",
      },
      {
        id: 2,
        label: "B) Wayne Rooney",
      },
      {
        id: 3,
        label: "C) Luis Su\u00e1rez",
      },
      {
        id: 4,
        label: "D) Cristiano Ronaldo",
      },
    ],
    correct: 3,
    insight:
      "Luis Su\u00e1rez received a seven-match ban for biting Otman Bakkal during a Dutch Eredivisie match, marking the beginning of his biting controversies.",
  },
  "2023-10-29": {
    date: "2023-10-29",
    question: "3:\nWho was the top goal scorer of the 2006 FIFA World Cup?",
    options: [
      {
        id: 1,
        label: "A) Ronaldo Naz\u00e1rio",
      },
      {
        id: 2,
        label: "B) Thierry Henry",
      },
      {
        id: 3,
        label: "C) Miroslav Klose",
      },
      {
        id: 4,
        label: "D) Francesco Totti",
      },
    ],
    correct: 3,
    insight:
      "Miroslav Klose scored 5 goals during the 2006 World Cup, winning the Golden Boot.",
  },
  "2023-10-30": {
    date: "2023-10-30",
    question: "23:\nWhat is the home ground of Paris Saint-Germain as of 2015?",
    options: [
      {
        id: 1,
        label: "A) Parc des Princes",
      },
      {
        id: 2,
        label: "B) Stade de France",
      },
      {
        id: 3,
        label: "C) San Siro",
      },
      {
        id: 4,
        label: "D) Nou Camp",
      },
    ],
    correct: 1,
    insight:
      "As of 2015, Paris Saint-Germain played their home matches at Parc des Princes, which has a seating capacity of 47,929.",
  },
  "2023-10-31": {
    date: "2023-10-31",
    question: "18:\nWho faced a tax evasion case in 2014?",
    options: [
      {
        id: 1,
        label: "A) Neymar",
      },
      {
        id: 2,
        label: "B) Lionel Messi",
      },
      {
        id: 3,
        label: "C) Cristiano Ronaldo",
      },
      {
        id: 4,
        label: "D) Xabi Alonso",
      },
    ],
    correct: 2,
    insight:
      "Lionel Messi and his father were charged with three counts of tax fraud in Spain for using tax havens in Belize and Uruguay.",
  },
  "2023-11-01": {
    date: "2023-11-01",
    question:
      "13:\nWhich team scored the most goals in the 2013-2014 Premier League season?",
    options: [
      {
        id: 1,
        label: "A) Manchester City",
      },
      {
        id: 2,
        label: "B) Chelsea",
      },
      {
        id: 3,
        label: "C) Arsenal",
      },
      {
        id: 4,
        label: "D) Liverpool",
      },
    ],
    correct: 1,
    insight:
      "Manchester City scored 102 goals during the 2013-2014 Premier League season, capturing the league title.",
  },
  "2023-11-02": {
    date: "2023-11-02",
    question: "Which player received a red card in the 2002 World Cup final?",
    options: [
      {
        id: 1,
        label: "A) Ronaldo",
      },
      {
        id: 2,
        label: "B) Oliver Kahn",
      },
      {
        id: 3,
        label: "C) Rivaldo",
      },
      {
        id: 4,
        label: "D) Dietmar Hamann",
      },
    ],
    correct: 4,
    insight:
      "Dietmar Hamann of Germany was the only player to receive a red card in the 2002 World Cup final against Brazil. Despite his sending off, Brazil won the match 2-0.",
  },
  "2023-11-03": {
    date: "2023-11-03",
    question:
      "Which club ended a 50-year league title drought by winning the Premier League in the 2004-2005 season?",
    options: [
      {
        id: 1,
        label: "A) Manchester United",
      },
      {
        id: 2,
        label: "B) Liverpool",
      },
      {
        id: 3,
        label: "C) Chelsea",
      },
      {
        id: 4,
        label: "D) Arsenal",
      },
    ],
    correct: 3,
    insight:
      "Chelsea won the Premier League title in the 2004-2005 season under the management of Jos\u00e9 Mourinho, ending a 50-year league title drought. They finished the season with a record 95 points, 12 points ahead of second-placed Arsenal.",
  },
  "2023-11-04": {
    date: "2023-11-04",
    question:
      "9:\nWhose girlfriend reportedly destroyed his Ferrari after catching him cheating?",
    options: [
      {
        id: 1,
        label: "A) Ronaldo Naz\u00e1rio",
      },
      {
        id: 2,
        label: "B) Wayne Rooney",
      },
      {
        id: 3,
        label: "C) Andrea Pirlo",
      },
      {
        id: 4,
        label: "D) Karim Benzema",
      },
    ],
    correct: 3,
    insight:
      "Deborah Roversi, Andrea Pirlo's ex-wife, reportedly destroyed his Ferrari after discovering he was having an affair.",
  },
  "2023-11-05": {
    date: "2023-11-05",
    question:
      "Which stadium hosted the 2001 UEFA Champions League final between Bayern Munich and Valencia?",
    options: [
      {
        id: 1,
        label: "A) Stadio Olimpico",
      },
      {
        id: 2,
        label: "B) Santiago Bernabeu",
      },
      {
        id: 3,
        label: "C) San Siro",
      },
      {
        id: 4,
        label: "D) Stade de France",
      },
    ],
    correct: 1,
    insight:
      "The 2001 UEFA Champions League final took place at the Stadio Olimpico in Milan, Italy. The match was decided by a penalty shootout, with Bayern Munich emerging victorious.",
  },
  "2023-11-06": {
    date: "2023-11-06",
    question:
      "Which team scored the most goals in the English Premier League during the 2002-2003 season?",
    options: [
      {
        id: 1,
        label: "A) Manchester United",
      },
      {
        id: 2,
        label: "B) Arsenal",
      },
      {
        id: 3,
        label: "C) Chelsea",
      },
      {
        id: 4,
        label: "D) Liverpool",
      },
    ],
    correct: 1,
    insight:
      "Manchester United scored 74 goals during the 2002-2003 English Premier League season, capturing their 8th Premier League title under Sir Alex Ferguson.",
  },
  "2023-11-07": {
    date: "2023-11-07",
    question:
      "2:\nWhich footballer was signed by AC Milan from Barcelona in the summer of 2008?",
    options: [
      {
        id: 1,
        label: "A) Andriy Shevchenko",
      },
      {
        id: 2,
        label: "B) Ronaldinho",
      },
      {
        id: 3,
        label: "C) David Beckham",
      },
      {
        id: 4,
        label: "D) Kaka",
      },
    ],
    correct: 2,
    insight:
      "AC Milan paid \u20ac21 million for Ronaldinho, who had fallen out of favor at Barcelona.",
  },
  "2023-11-08": {
    date: "2023-11-08",
    question:
      "Who led the assist chart in the English Premier League for the 2002-2003 season?",
    options: [
      {
        id: 1,
        label: "A) David Beckham",
      },
      {
        id: 2,
        label: "B) Ryan Giggs",
      },
      {
        id: 3,
        label: "C) Thierry Henry",
      },
      {
        id: 4,
        label: "D) Steven Gerrard",
      },
    ],
    correct: 1,
    insight:
      "David Beckham provided 10 assists during the 2002-2003 English Premier League season, which was his final season with Manchester United before moving to Real Madrid.",
  },
  "2023-11-09": {
    date: "2023-11-09",
    question:
      "2:\nWhich WAG became infamous for suing newspapers for defamation?",
    options: [
      {
        id: 1,
        label: "A) Victoria Beckham",
      },
      {
        id: 2,
        label: "B) Coleen Rooney",
      },
      {
        id: 3,
        label: "C) Abbey Clancy",
      },
      {
        id: 4,
        label: "D) Cheryl Cole",
      },
    ],
    correct: 2,
    insight:
      "Coleen Rooney has sued several media outlets for defamation and has been very vocal about protecting her reputation.",
  },
  "2023-11-10": {
    date: "2023-11-10",
    question:
      "5:\nWhich footballer's relationship caused a media uproar due to an alleged involvement with an escort?",
    options: [
      {
        id: 1,
        label: "A) Peter Crouch",
      },
      {
        id: 2,
        label: "B) Neymar",
      },
      {
        id: 3,
        label: "C) Cristiano Ronaldo",
      },
      {
        id: 4,
        label: "D) Zinedine Zidane",
      },
    ],
    correct: 1,
    insight:
      "Peter Crouch's relationship with Abbey Clancy faced scrutiny when allegations arose that he was involved with an escort.",
  },
  "2023-11-11": {
    date: "2023-11-11",
    question:
      "2:\nIn which stadium did FC Barcelona win the 2009 UEFA Champions League?",
    options: [
      {
        id: 1,
        label: "A) Old Trafford",
      },
      {
        id: 2,
        label: "B) Camp Nou",
      },
      {
        id: 3,
        label: "C) San Siro",
      },
      {
        id: 4,
        label: "D) Stadio Olimpico",
      },
    ],
    correct: 4,
    insight:
      "FC Barcelona defeated Manchester United 2-0 in the 2009 UEFA Champions League final at the Stadio Olimpico in Rome.",
  },
  "2023-11-12": {
    date: "2023-11-12",
    question: "7:\nWho was the top scorer in the 2012 UEFA Euro championship?",
    options: [
      {
        id: 1,
        label: "A) Cristiano Ronaldo",
      },
      {
        id: 2,
        label: "B) Fernando Torres",
      },
      {
        id: 3,
        label: "C) Wayne Rooney",
      },
      {
        id: 4,
        label: "D) Zlatan Ibrahimovic",
      },
    ],
    correct: 2,
    insight:
      "Fernando Torres was awarded the Golden Boot for scoring three goals and providing an assist.",
  },
  "2023-11-13": {
    date: "2023-11-13",
    question:
      "2:\nWhich player did Manchester United sign for a British record fee in 2014?",
    options: [
      {
        id: 1,
        label: "A) Di Maria",
      },
      {
        id: 2,
        label: "B) Paul Pogba",
      },
      {
        id: 3,
        label: "C) Romelu Lukaku",
      },
      {
        id: 4,
        label: "D) Juan Mata",
      },
    ],
    correct: 1,
    insight:
      "Angel Di Maria was signed for \u00a359.7 million, setting a British transfer record at the time.",
  },
  "2023-11-14": {
    date: "2023-11-14",
    question:
      "Which club won the treble (League, Domestic Cup, and UEFA Champions League) in the 2008-2009 season?",
    options: [
      {
        id: 1,
        label: "A) Manchester United",
      },
      {
        id: 2,
        label: "B) FC Barcelona",
      },
      {
        id: 3,
        label: "C) AC Milan",
      },
      {
        id: 4,
        label: "D) Chelsea",
      },
    ],
    correct: 2,
    insight:
      "FC Barcelona won the treble in the 2008-2009 season, becoming the first Spanish club to achieve this feat.",
  },
  "2023-11-15": {
    date: "2023-11-15",
    question: "12:\nWho led Serie A in assists during the 2013-2014 season?",
    options: [
      {
        id: 1,
        label: "A) Andrea Pirlo",
      },
      {
        id: 2,
        label: "B) Francesco Totti",
      },
      {
        id: 3,
        label: "C) Antonio Candreva",
      },
      {
        id: 4,
        label: "D) Marek Hamsik",
      },
    ],
    correct: 3,
    insight:
      "Antonio Candreva led Serie A with 16 assists during the 2013-2014 season.",
  },
  "2023-11-16": {
    date: "2023-11-16",
    question:
      "Who became the world's most expensive footballer when he transferred from Barcelona to Real Madrid in 2000?",
    options: [
      {
        id: 1,
        label: "A) Zinedine Zidane",
      },
      {
        id: 2,
        label: "B) Lu\u00eds Figo",
      },
      {
        id: 3,
        label: "C) Ronaldo Naz\u00e1rio",
      },
      {
        id: 4,
        label: "D) David Beckham",
      },
    ],
    correct: 2,
    insight:
      "Lu\u00eds Figo's transfer from Barcelona to Real Madrid in 2000 was worth \u20ac60 million, making him the world's most expensive player at that time. His move also caused significant controversy due to the fierce rivalry between the two clubs.",
  },
  "2023-11-17": {
    date: "2023-11-17",
    question:
      "4:\nWhich player led the assists table in the Bundesliga for the 2008-2009 season?",
    options: [
      {
        id: 1,
        label: "A) Mesut \u00d6zil",
      },
      {
        id: 2,
        label: "B) Franck Rib\u00e9ry",
      },
      {
        id: 3,
        label: "C) Bastian Schweinsteiger",
      },
      {
        id: 4,
        label: "D) Diego",
      },
    ],
    correct: 4,
    insight:
      "Diego, who was playing for Werder Bremen at the time, led the Bundesliga with 17 assists in the 2008-2009 season.",
  },
  "2023-11-18": {
    date: "2023-11-18",
    question:
      "Who won the Golden Shoe for being the top scorer in European leagues for the 2001-2002 season?",
    options: [
      {
        id: 1,
        label: "A) Thierry Henry",
      },
      {
        id: 2,
        label: "B) Ronaldo",
      },
      {
        id: 3,
        label: "C) Ra\u00fal",
      },
      {
        id: 4,
        label: "D) Jardel",
      },
    ],
    correct: 4,
    insight:
      "Jardel of Sporting CP won the Golden Shoe for the 2001-2002 season with 42 goals.",
  },
  "2023-11-19": {
    date: "2023-11-19",
    question: "Which manager was accused of tapping up Ashley Cole in 2005?",
    options: [
      {
        id: 1,
        label: "A) Alex Ferguson",
      },
      {
        id: 2,
        label: "B) Ars\u00e8ne Wenger",
      },
      {
        id: 3,
        label: "C) Jos\u00e9 Mourinho",
      },
      {
        id: 4,
        label: "D) Rafael Ben\u00edtez",
      },
    ],
    correct: 3,
    insight:
      "Jos\u00e9 Mourinho was accused of tapping up Ashley Cole, then an Arsenal player, in a meeting at a hotel. Both Chelsea and Mourinho faced disciplinary action, with the club being fined \u00a3300,000 and Mourinho himself receiving a \u00a3200,000 fine.",
  },
  "2023-11-20": {
    date: "2023-11-20",
    question:
      "4:\nWhich player became the youngest to score a hat-trick in the Champions League?",
    options: [
      {
        id: 1,
        label: "A) Lionel Messi",
      },
      {
        id: 2,
        label: "B) Wayne Rooney",
      },
      {
        id: 3,
        label: "C) Ra\u00fal",
      },
      {
        id: 4,
        label: "D) Kak\u00e1",
      },
    ],
    correct: 1,
    insight:
      "Lionel Messi became the youngest player to score a hat-trick in the UEFA Champions League at the age of 21, during a match against Arsenal in the 2009-2010 season.",
  },
  "2023-11-21": {
    date: "2023-11-21",
    question:
      "Who was the most expensive football transfer in the world in 2001?",
    options: [
      {
        id: 1,
        label: "A) Thierry Henry",
      },
      {
        id: 2,
        label: "B) Zinedine Zidane",
      },
      {
        id: 3,
        label: "C) Lu\u00eds Figo",
      },
      {
        id: 4,
        label: "D) Rivaldo",
      },
    ],
    correct: 2,
    insight:
      "Zinedine Zidane was transferred from Juventus to Real Madrid for \u20ac77.5 million, making it the world's most expensive transfer at the time.",
  },
  "2023-11-22": {
    date: "2023-11-22",
    question:
      "3:\nWho received a red card for his foul on Ricardo Kak\u00e1 during the 2009 Confederations Cup final?",
    options: [
      {
        id: 1,
        label: "A) Clint Dempsey",
      },
      {
        id: 2,
        label: "B) Michael Bradley",
      },
      {
        id: 3,
        label: "C) Landon Donovan",
      },
      {
        id: 4,
        label: "D) Tim Howard",
      },
    ],
    correct: 2,
    insight:
      "Michael Bradley was sent off in the 87th minute of the 2009 Confederations Cup final between the USA and Brazil, making the American side's task even more challenging.",
  },
};

const AppContainer = styled.div`
  font-family: "Impact", sans-serif; // Sporty Font
  height: 100vh;
  background: linear-gradient(
    to right,
    #56ab2f,
    #a8e063
  ); // Green field gradient
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Score = styled(motion.div)`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 2.5em;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const FloatingCard = styled(motion.div)`
  background: #fff;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  min-width: 300px;
  min-height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 90vw;
`;

const BubbleOption = styled(motion.div)`
  background: ${(props) => props.color || "#ddd"};
  color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 15px;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
  }
`;

function getScore(attempt) {
  if (attempt == 1) return 100;
  if (attempt == 2) return 50;
  return 25;
}

function App() {
  const [score, setScore] = useState(localStorage.getItem("score") || 0);
  const [flipped, setFlipped] = useState(false);
  const [answer, setAnswer] = useState(localStorage.getItem("answer") || null);
  const [date, setDate] = useState(TodaysDate());
  const [attempt, setAttempt] = useState(1);
  const [message, setMessage] = useState(false);
  const [celeb, setCeleb] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState(null);

  const handleOptionClick = (isCorrect, label) => {
    if (isCorrect) {
      setMessage(true);
      localStorage.setItem("answer", date);
      let newscore = parseInt(score) + getScore(attempt);
      setScore(newscore);
      localStorage.setItem("score", newscore);
      setCeleb(true);
      setCorrectAnswer(label);
    }
    setFlipped(true);
    setAttempt(attempt + 1);
    setTimeout(() => setFlipped(false), 1000);
    setTimeout(() => setCeleb(false), 2000);
  };

  return (
    <AppContainer>
      <Score
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Score: {score}
      </Score>
      <div style={{ fontSize: 24, marginTop: 80 }}>
        WELCOME TO THE SOCCER QUIZ
      </div>
      <div>One interesting soccer adventure for you each day</div>
      <br></br>
      {celeb && <Confetti width={1500} height={2000} />}

      {localStorage.getItem("answer") == date ? (
        <FloatingCard>
          <h1>For the question</h1>
          <h2>{questions[date].question}</h2>
          <h2>Correct Answer: {correctAnswer}</h2>
          <h2>Insight</h2>
          <h2>{questions[date].insight}</h2>
          <h3>
            Ghagri bhare tez tez ,kuch na kuch chalak jaae , for more questions
            dude kal waapis aae
          </h3>
        </FloatingCard>
      ) : (
        <FloatingCard
          transition={{ duration: 0.8, type: "spring", stiffness: 80 }}
        >
          {!flipped ? (
            <>
              <h2>{questions[date].question}</h2>
              {questions[date].options.map((o) => {
                return (
                  <BubbleOption
                    color="#E57373"
                    onClick={() =>
                      handleOptionClick(
                        o.id == questions[date].correct,
                        o.label
                      )
                    }
                  >
                    {o.label}
                  </BubbleOption>
                );
              })}
            </>
          ) : (
            <h2>
              {message
                ? "Correct!  Zizou would be proud of you!!!"
                : `Try Again  ${3 - attempt + 1} attempts remaining`}
            </h2>
          )}
        </FloatingCard>
      )}
    </AppContainer>
  );
}

export default App;
